import { ReactNode } from 'react';
import {
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPhone,
  FaWhatsapp,
  FaYoutube,
} from 'react-icons/fa';

export type ContactInfoItem = {
  icon: ReactNode;
  title: string;
  details: string;
  helper: string;
  color: string;
  bg: string;
  link: string;
};

export type BusinessHourItem = {
  days: string;
  hours: string;
  accent: string;
  bg: string;
};

export type SocialLinkItem = {
  href: string;
  icon: ReactNode;
  label: string;
  color: string;
  bg: string;
};

export const contactInfo: ContactInfoItem[] = [
  {
    icon: <FaPhone data-component-id="src/components/contact/contactData.tsx:39:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="39" data-component-end-line="39" data-component-file="contactData.tsx" data-component-name="FaPhone" data-component-content="%7B%22elementName%22%3A%22FaPhone%22%7D" size={28} />,
    title: 'Phone',
    details: '+1 (226) 962-6664',
    helper: 'Call for repair help or booking support',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
    link: 'tel:+12269626664',
  },
  {
    icon: <FaWhatsapp data-component-id="src/components/contact/contactData.tsx:48:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="48" data-component-end-line="48" data-component-file="contactData.tsx" data-component-name="FaWhatsapp" data-component-content="%7B%22elementName%22%3A%22FaWhatsapp%22%7D" size={28} />,
    title: 'WhatsApp',
    details: '+1 (226) 962-6664',
    helper: 'Quick contact for repair questions',
    color: '#25D366',
    bg: 'rgba(37, 211, 102, 0.1)',
    link: 'https://wa.me/12269626664',
  },
  {
    icon: <FaEnvelope data-component-id="src/components/contact/contactData.tsx:57:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="57" data-component-end-line="57" data-component-file="contactData.tsx" data-component-name="FaEnvelope" data-component-content="%7B%22elementName%22%3A%22FaEnvelope%22%7D" size={28} />,
    title: 'Email',
    details: 'nskrepairca@gmail.com',
    helper: 'Best for quotes and business inquiries',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
    link: 'mailto:nskrepairca@gmail.com',
  },
];

export const businessHours: BusinessHourItem[] = [
  {
    days: 'Monday - Tuesday',
    hours: '10:00 AM - 10:00 PM',
    accent: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.08)',
  },
  {
    days: 'Wednesday - Friday',
    hours: '6:00 PM - 10:00 PM',
    accent: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.08)',
  },
  {
    days: 'Saturday - Sunday',
    hours: '4:00 PM - 10:00 PM',
    accent: '#22C55E',
    bg: 'rgba(34, 197, 94, 0.08)',
  },
];

export const trustPoints = [
  'Fast response for repair questions',
  'Support for phones, tablets, and laptops',
  'Business and personal device repair',
  'Clear communication and local service',
];

export const socialLinks: SocialLinkItem[] = [
  {
    href: 'https://www.facebook.com/people/NSK-Repair/61583732162928',
    icon: <FaFacebook data-component-id="src/components/contact/contactData.tsx:98:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="98" data-component-end-line="98" data-component-file="contactData.tsx" data-component-name="FaFacebook" data-component-content="%7B%22elementName%22%3A%22FaFacebook%22%7D" size={22} />,
    label: 'Facebook',
    color: '#1E90FF',
    bg: 'rgba(30, 144, 255, 0.1)',
  },
  {
    href: 'https://www.instagram.com/nskrepairca',
    icon: <FaInstagram data-component-id="src/components/contact/contactData.tsx:105:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="105" data-component-end-line="105" data-component-file="contactData.tsx" data-component-name="FaInstagram" data-component-content="%7B%22elementName%22%3A%22FaInstagram%22%7D" size={22} />,
    label: 'Instagram',
    color: '#FF6F00',
    bg: 'rgba(255, 111, 0, 0.1)',
  },
  {
    href: 'https://www.youtube.com/@NSKRepair',
    icon: <FaYoutube data-component-id="src/components/contact/contactData.tsx:112:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="112" data-component-end-line="112" data-component-file="contactData.tsx" data-component-name="FaYoutube" data-component-content="%7B%22elementName%22%3A%22FaYoutube%22%7D" size={22} />,
    label: 'YouTube',
    color: '#EF4444',
    bg: 'rgba(239, 68, 68, 0.1)',
  },
  {
    href: 'https://www.linkedin.com/company/nsk-repair',
    icon: <FaLinkedin data-component-id="src/components/contact/contactData.tsx:119:10" data-component-path="src/components/contact/contactData.tsx" data-component-line="119" data-component-end-line="119" data-component-file="contactData.tsx" data-component-name="FaLinkedin" data-component-content="%7B%22elementName%22%3A%22FaLinkedin%22%7D" size={22} />,
    label: 'LinkedIn',
    color: '#0077B5',
    bg: 'rgba(0, 119, 181, 0.1)',
  },
];

export const services = [
  'Screen Replacement',
  'Battery Replacement',
  'Charging Port Repair',
  'Back Glass Replacement',
  'Camera Repair',
  'Speaker Repair',
  'Microphone Repair',
  'Button Repair (Power / Volume)',
  'Water Damage Repair',
  'Software Issue / Update',
  'Data Recovery',
  'Unlocking Service',
  'Diagnostic Service',
  'Windows Installation',
  'Other',
];

export const heroTrustChips = [
  'Fast reply',
  'Local support',
  'Business inquiries welcome',
  'Trusted repair help',
  'Phones, tablets, and laptops',
  'Clear communication',
];
